import React from 'react';
import Table, { TableProps } from 'react-bootstrap/Table';

type AccessibleTableProps = Omit<TableProps, 'responsive'> & { scrollLabel: string };

export default function AccessibleTable({ scrollLabel, ...props }: AccessibleTableProps) {
  return <div className="table-responsive" role="region" aria-label={scrollLabel} tabIndex={0}>
    <Table {...props} />
  </div>;
}
